module.exports = __webpack_public_path__ + "img/nomination_form.769f8faf.svg";